/*
 * Hostnames represents the account or organization "username"
 * used to serve content at <username>.gitbook.io
 */

const HOSTNAMES_REGEX = /^[a-z0-9][a-z0-9-]{1,30}[a-z0-9]$/;

export const RESERVED_HOSTNAMES = [
    'www',
    'docs',
    'developer',
    'developers',
    'changelog',
    'privacy',
    'help',
    'hosting',
];
const RESERVED_SUBDOMAINS_REGEXP = new RegExp(
    `^(${RESERVED_HOSTNAMES.join('|')}|[a-z0-9]+-hosting)$`
);

/**
 * Returns whether the hostname is valid, eg. matches the validation rules in Firestore.
 */
export function isValidHostname(str: string): boolean {
    return (
        // Limit used characters
        HOSTNAMES_REGEX.test(str) &&
        // Harcoded set of prohibited hostnames
        !isReservedHostname(str)
    );
}

/**
 * Returns whether the provided value is a reserved/prohibited hostname.
 */
export function isReservedHostname(str: string): boolean {
    return RESERVED_SUBDOMAINS_REGEXP.test(str);
}

/**
 * Extract the subdomain from a full hostname.
 * Handles multiple levels of subdomains (e.g., "sub.domain.gitbook.io" -> "sub.domain").
 */
export function getSubdomainFromHostname(hostname: string): string {
    const parts = hostname.split('.');
    if (parts.length <= 2 && parts[0]) {
        return parts[0];
    }
    return parts.slice(0, -2).join('.');
}
